import {reducerWithInitialState} from "typescript-fsa-reducers";
import { actions } from "../actions/Action";
import { deepCopyTableThingyState, LoginInitialState } from "../typing/loginstate";



export default reducerWithInitialState(LoginInitialState)
        .case(actions.createUser, (state,payload) => {
            // create a deepcopy of state and update the variables 
            // ONLY UPDATE THE DEPCOPY AND RETURN IT
            const deepCopy=deepCopyTableThingyState(state);
            deepCopy.model.user = payload.NewUser.username;
            
            return deepCopy;
        })
        // .case(actions.showQrCode, (state, payload) => {
        //     const deepCopy=deepCopyTableThingyState(state);
        //     deepCopy.view.token = payload.token;
        // })
        // WHy errors this crap, Ask GF
        ;

       